
class EntityDef {

  constructor(entityName) {
    this.baseDef = {
      name: entityName, privilege: {privilege: 65535}
    };
    this.fieldsDef = {};
  }

  addField(fieldName, description, type, isKey = false) {
    let typeObj = type;
    if (typeof typeObj === 'string') {
      typeObj = {type: type, isKey: isKey};
    }
    this.fieldsDef[fieldName] = {name: fieldName, description: description, type: typeObj, privilege: {privilege: 65535}};
  }
}

export default EntityDef;
